// extracted by mini-css-extract-plugin
export default {"toggleButton":"Attachments_toggleButton__Pv0eK"};